import { ProjectTreeNodeT } from "components/project/layers/hooks";
import { useProjectContext } from "components/project/projects/context";
import {
  useAcceptShapefileChanges,
  useCancelShapefileChanges
} from "components/project/shapefiles/hooks";

import { EditableLabel, FlexItem, LeafTitle } from "../../../../shared";

export interface IEditableShapefileNode {
  node: ProjectTreeNodeT;
}

export function EditableShapefileNode({ node }: IEditableShapefileNode) {
  const { selectedProjectId } = useProjectContext();

  const acceptChanges = useAcceptShapefileChanges({ node, projectId: selectedProjectId });
  const cancelChanges = useCancelShapefileChanges();

  return (
    <LeafTitle>
      <FlexItem>
        <EditableLabel
          isLoading={acceptChanges.isLoading}
          onCancel={cancelChanges.mutate}
          onChange={acceptChanges.mutate}
        />
      </FlexItem>
    </LeafTitle>
  );
}
